import { IUserInfo } from '../shared/core/user-info.model';
import { IUserInProject } from '../shared/core';

export class UsersProject{
    projectId: string;
    users: IUserInProject[];
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/users/user-management.model.ts